export const appXIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M0 0H24V24H0z"/><path fill="currentColor" fill-rule="nonzero" d="M10.219 17L12 13.497 13.781 17 16 17 13.234 11.959 15.93 7 13.736 7 12 10.448 10.264 7 8.07 7 10.766 11.959 8 17z"/></g></svg>`,
    name: 'x' as const
};